export default "__VITE_ASSET__CoCcw5ty__"